// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"d966a482","76":"68ac4dde","174":"97555f38","337":"0da60f4c","580":"dc5366ac","740":"d486c3c6"}[chunkId] + ".chunk.js";
};